module.exports = __webpack_public_path__ + "img/sites.6a1df830.png";